import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import React from 'react'
import { getDayTypeName } from '../helpers/TimesheetDayType'

const ScheduleContextMenuDayLabel = ({ dayType, searchQuery, isSelected = false }) => {
  const { t } = useLocalize()
  const dayTypeName = getDayTypeName(dayType, t)

  const highlightText = (text: string, query: string) => {
    if (!query) return text

    const regex = new RegExp(`(${query})`, 'gi')
    const parts = text.split(regex)

    return parts.map((part, index) => {
      if (part.toLowerCase() === query.toLowerCase()) {
        return (
          <span key={index} className="tw-bg-yellow-200">
            {part}
          </span>
        )
      }
      return part
    })
  }

  return (
    <span className={`tw-text-sm tw-font-normal tw-text-content-base ${isSelected && 'tw-font-semibold'}`}>
      {highlightText(dayTypeName, searchQuery)}
    </span>
  )
}

export default ScheduleContextMenuDayLabel
